import React from "react";
import FunnelInsightCard from "./FunnelInsightCard";
import { buildProductSkuEconomicsChart } from "./funnelChartUtils";
import {
  cleanLines,
  extractTitle,
  stripTitleLines,
  extractTableBlock,
  splitByHeading,
  splitSkuBlocks,
  toBullets,
  toParagraphs,
  extractVerdict,
} from "./funnelUtils";

const FunnelProductSkuEconomics = ({ markdown = "" }) => {
  const title = extractTitle(markdown) || "Product & SKU Economics";
  const lines = stripTitleLines(cleanLines(markdown));
  const { tail } = splitByHeading(lines, "What Does This Mean?");
  const skuBlocks = splitSkuBlocks(lines);
  const meaningBullets = toBullets(tail);
  let meaningParagraphs = toParagraphs(tail);
  const verdict = extractVerdict(meaningParagraphs);
  if (verdict) meaningParagraphs = meaningParagraphs.slice(0, -1);

  const sections = skuBlocks.map((block) => {
    const { table } = extractTableBlock(block.lines);
    const renamedTable =
      table && Array.isArray(table.rows)
        ? {
            ...table,
            rows: table.rows.map((row) => {
              if (!row || row.length === 0) return row;
              const metricIndex = row.length >= 3 ? 1 : 0;
              const metric = row[metricIndex];
              const text = String(metric || "");
              let renamed = text;
              if (text === "SKU CM1") {
                renamed = "SKU Contribution Before Marketing";
              } else if (text === "SKU CM2") {
                renamed = "SKU Contribution After Marketing";
              } else if (text === "SKU CM2 %") {
                renamed = "SKU Contribution After Marketing %";
              }
              if (metricIndex === 1) {
                return [row[0], renamed, ...row.slice(2)];
              }
              return [renamed, ...row.slice(1)];
            }),
          }
        : table;
    return {
      title: block.title,
      table: renamedTable,
    };
  });
  const chart = buildProductSkuEconomicsChart(sections);

  const finalSections = [
    {
      title: "SKU Portfolio View",
      chart,
      chartTitle: "SKU Economics Bubble Map",
      chartSubtitle:
        "Each bubble represents a SKU using revenue, contribution, and scale in one shot.",
    },
    ...sections,
  ];

  if (meaningBullets.length || meaningParagraphs.length || verdict) {
    finalSections.push({
      title: "What Does This Mean?",
      bullets: meaningBullets,
      paragraphs: meaningParagraphs,
      verdict,
    });
  }

  return (
    <FunnelInsightCard
      title={title}
      kicker="SKU Contribution"
      sections={finalSections}
    />
  );
};

export default FunnelProductSkuEconomics;
